import { FormBuilderSection } from './models'

export const getFormBuilderStructure = (i18n): FormBuilderSection[] => [
  {
    groups: [
      {
        key: 'generalDetails',
        label: i18n.t('module:RegistrationForm:groups:generalDetails'),
        subGroups: [
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.photo',
                label: i18n.t('module:RegistrationForm:fields:profilePhoto'),
              },
              {
                defaultDisabled: {
                  enquiry: true,
                  registration: true,
                },
                key: 'fields.child.firstName',
                label: i18n.t('module:RegistrationForm:fields:firstName'),
              },
              {
                key: 'fields.child.middleNames',
                label: i18n.t('module:RegistrationForm:fields:middleNames'),
              },
              {
                defaultDisabled: {
                  enquiry: true,
                  registration: true,
                },
                key: 'fields.child.surname',
                label: i18n.t('module:RegistrationForm:fields:surname'),
              },
              {
                key: 'fields.child.displayName',
                label: i18n.t('module:RegistrationForm:fields:displayName'),
                required: true,
              },
              {
                key: 'fields.child.gender',
                label: i18n.t('module:RegistrationForm:fields:gender'),
                placeholder: i18n.t('module:RegistrationForm:fields:genderPlaceholder'),
                required: true,
              },
              {
                key: 'fields.child.birthDate',
                label: i18n.t('module:RegistrationForm:fields:dateOfBirth'),
                placeholder: i18n.t('global:selectDate'),
              },
              {
                key: 'fields.child.ethnicity',
                label: i18n.t('module:RegistrationForm:fields:ethnicity'),
                placeholder: 'Select child\'s ethnicity group',
              },
              {
                key: 'fields.child.religion',
                label: i18n.t('module:RegistrationForm:fields:religion'),
                placeholder: 'Select child\'s religion',
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.address',
                label: i18n.t('module:RegistrationForm:fields:address'),
              },
              {
                key: 'fields.child.information.postcode',
                label: i18n.t('module:RegistrationForm:fields:postcode'),
              },
              {
                key: 'fields.child.codeReference',
                label: i18n.t('module:RegistrationForm:fields:referenceCode'),
              },
              {
                key: 'fields.child.taxFreeChildcareCodeReference',
                label: i18n.t('module:RegistrationForm:fields:taxFreeChildcareCode'),
              },
              {
                key: 'fields.child.fundingCode',
                label: i18n.t('module:RegistrationForm:fields:fundingCode'),
              },
            ],
            key: 'generalDetails',
            label: null,
          },
        ],
      },
      {
        key: 'familyInformation',
        label: i18n.t('module:RegistrationForm:groups:familyInformation'),
        subGroups: [
          {
            fields: [
              {
                key: 'fields.child.profile.siblings',
                label: i18n.t('module:RegistrationForm:fields:siblings'),
              },
              {
                key: 'fields.child.profile.familyPosition',
                label: i18n.t('module:RegistrationForm:fields:positionInFamily'),
              },
              {
                key: 'fields.child.profile.familySpokenLanguage',
                label: i18n.t('module:RegistrationForm:fields:languageAtHome'),
                placeholder: i18n.t('module:RegistrationForm:fields:languageAtHomePlaceholder'),
              },
              {
                key: 'fields.child.profile.familyMaritalStatus',
                label: i18n.t('module:RegistrationForm:fields:parentsMaritalStatus'),
                placeholder: i18n.t('module:RegistrationForm:fields:parentsMaritalStatusPlaceholder'),
              },
              {
                key: 'fields.child.profile.parentsAreServingArmedForcesPersonnel',
                label: i18n.t('module:RegistrationForm:fields:isChildOfServingArmedForcesPersonnel'),
              },
            ],
            key: 'familyInformation',
            label: null,
          },
        ],
      },
      {
        key: 'medicalDetails',
        label: i18n.t('module:RegistrationForm:groups:medicalDetails'),
        subGroups: [
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.profile.medicalInformation',
                label: i18n.t('module:RegistrationForm:fields:medicalInformation'),
                placeholder: i18n.t('module:RegistrationForm:fields:medicalInformationPlaceholder'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.allergies',
                label: i18n.t('module:RegistrationForm:fields:allergies'),
                required: true,
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.allergiesDetails',
                label: i18n.t('module:RegistrationForm:fields:allergiesDetails'),
              },
            ],
            key: 'health',
            label: i18n.t('module:RegistrationForm:subGroups:health'),
          },
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.information.dietaryReq',
                label: i18n.t('module:RegistrationForm:fields:dietaryRequirements'),
                placeholder: i18n.t('module:RegistrationForm:fields:dietaryRequirementsPlaceholder'),
                required: true,
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.dietaryReqDesc',
                label: i18n.t('module:RegistrationForm:fields:additionalNote'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.profile.isFussyEater',
                label: i18n.t('module:RegistrationForm:fields:fussyEater'),
              },
            ],
            key: 'diet',
            label: i18n.t('module:RegistrationForm:subGroups:diet'),
          },
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.information.canReceiveMedicine',
                label: i18n.t('module:RegistrationForm:fields:canReceiveMedicine'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.hasPermissionToBeTakenToHospital',
                label: i18n.t('module:RegistrationForm:fields:hasPermissionToBeTakenToAHospital'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.applyPermissions.patches',
                label: i18n.t('module:RegistrationForm:fields:hasPermissionToHaveAdhesiveDressingsApplied'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.applyPermissions.sunCream',
                label: i18n.t('module:RegistrationForm:fields:sunCream'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.applyPermissions.nappyCream',
                label: i18n.t('module:RegistrationForm:fields:nappyCream'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.applyPermissions.facePaint',
                label: i18n.t('module:RegistrationForm:fields:facePaint'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.canConsumeFoodWithNutTraces',
                label: i18n.t('module:RegistrationForm:fields:canConsumeFoodWithNutTraces'),
              },
            ],
            key: 'permissions',
            label: i18n.t('module:RegistrationForm:subGroups:permissions'),
          },
        ],
      },
      {
        key: 'development',
        label: i18n.t('module:RegistrationForm:groups:development'),
        subGroups: [
          {
            fields: [
              {
                key: 'fields.child.information.toiletTrained',
                label: i18n.t('module:RegistrationForm:fields:toileting'),
              },
              {
                key: 'fields.child.information.drinkingMethod',
                label: i18n.t('module:RegistrationForm:fields:drinkingFrom'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.profile.specialEducationalNeeds',
                label: i18n.t('module:RegistrationForm:fields:specialEducationalNeeds'),
                placeholder: i18n.t('module:RegistrationForm:fields:anyAdditionalDetails'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.profile.englishAsAdditionalLanguage',
                label: i18n.t('module:RegistrationForm:fields:englishAsAdditionalLanguage'),
                placeholder: i18n.t('module:RegistrationForm:fields:anyAdditionalDetails'),
              },
              {
                key: 'fields.child.profile.languageCapability',
                label: i18n.t('module:RegistrationForm:fields:languageSkills'),
                placeholder: i18n.t('module:RegistrationForm:fields:languageSkillsPlaceholder'),
              },
              {
                key: 'fields.child.profile.movementCapability',
                label: i18n.t('module:RegistrationForm:fields:physicalSkills'),
                placeholder: i18n.t('module:RegistrationForm:fields:physicalSkillsPlaceholder'),
              },
              {
                key: 'fields.child.profile.childBehavior',
                label: i18n.t('module:RegistrationForm:fields:socialSkills'),
                placeholder: i18n.t('module:RegistrationForm:fields:socialSkillsPlaceholder'),
              },
            ],
            key: 'skills',
            label: i18n.t('module:RegistrationForm:subGroups:skills'),
          },
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.information.daytimeSleepingBehavior',
                label: i18n.t('module:RegistrationForm:fields:sleepsDuringTheDay'),
                placeholder: i18n.t('module:RegistrationForm:fields:anyAdditionalDetails'),
              },
              {
                key: 'fields.child.profile.routine',
                label: i18n.t('module:RegistrationForm:fields:dailyRoutine'),
                placeholder: i18n.t('module:RegistrationForm:fields:dailyRoutinePlaceholder'),
              },
              {
                key: 'fields.child.profile.attendsOtherSetting',
                label: i18n.t('module:RegistrationForm:fields:attendsOtherSetting'),
                placeholder: i18n.t('module:RegistrationForm:fields:attendsOtherSettingPlaceholder'),
              },
            ],
            key: 'routine',
            label: i18n.t('module:RegistrationForm:subGroups:routine'),
          },
        ],
      },
      {
        key: 'permissions',
        label: i18n.t('module:RegistrationForm:groups:permissions'),
        subGroups: [
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.information.canBePhotographed',
                label: i18n.t('module:RegistrationForm:fields:canBePhotographed'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.canBeTaggedInGroupPhotos',
                label: i18n.t('module:RegistrationForm:fields:canBeTaggedInGroupPhotos'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.socialMediaPhotoSharingPermitted',
                label: i18n.t('module:RegistrationForm:fields:socialMediaPhotoSharingPermitted'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.closedSocialMediaPhotoSharingPermitted',
                label: i18n.t('module:RegistrationForm:fields:closedSocialMediaPhotoSharingPermitted'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.useOnSiteMediaPermitted',
                label: i18n.t('module:RegistrationForm:fields:useOnSiteMediaPermitted'),
              },
              {
                doubleColumn: true,
                key: 'fields.child.information.otherMarketingMaterialPhotoSharingPermitted',
                label: i18n.t('module:RegistrationForm:fields:otherMarketingMaterialPhotoSharingPermitted'),
              },
            ],
            key: 'skills',
            label: i18n.t('module:RegistrationForm:subGroups:media'),
          },
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.information.travelPermissions.canGoToExternalOutgoings',
                label: i18n.t('module:RegistrationForm:fields:canGoToExternalOutgoings'),
              },
            ],
            key: 'play',
            label: i18n.t('module:RegistrationForm:subGroups:play'),
          },
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.information.travelPermissions.canTakeTheBus',
                label: i18n.t('module:RegistrationForm:fields:canTakeTheBus'),
              },
            ],
            key: 'safety',
            label: i18n.t('module:RegistrationForm:subGroups:safety'),
          },
        ],
      },
      {
        key: 'likesDislikes',
        label: i18n.t('module:RegistrationForm:groups:likesDislikes'),
        subGroups: [
          {
            fields: [
              {
                key: 'fields.child.profile.toysPreference',
                label: i18n.t('module:RegistrationForm:fields:toys'),
                placeholder: i18n.t('module:RegistrationForm:fields:toysPlaceholder'),
              },
              {
                key: 'fields.child.profile.booksPreference',
                label: i18n.t('module:RegistrationForm:fields:books'),
                placeholder: i18n.t('module:RegistrationForm:fields:booksPlaceholder'),
              },
              {
                key: 'fields.child.profile.foodsPreference',
                label: i18n.t('module:RegistrationForm:fields:food'),
                placeholder: i18n.t('module:RegistrationForm:fields:foodPlaceholder'),
              },
              {
                key: 'fields.child.profile.otherPreference',
                label: i18n.t('module:RegistrationForm:fields:interests'),
              },
            ],
            key: 'likesDislikes',
            label: null,
          },
        ],
      },
    ],
    key: 'childInformation',
    label: i18n.t('module:RegistrationForm:sections:childInformation'),
  },
  {
    groups: [
      {
        key: 'parentInformation',
        label: null,
        subGroups: [
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.carerChildRelations.carer.photo',
                label: i18n.t('module:RegistrationForm:fields:profilePhoto'),
              },
              {
                key: 'fields.child.carerChildRelations.carer.title',
                label: i18n.t('module:RegistrationForm:fields:title'),
              },
              {
                defaultDisabled: {
                  enquiry: true,
                  registration: true,
                },
                key: 'fields.child.carerChildRelations.carer.firstName',
                label: i18n.t('module:RegistrationForm:fields:firstName'),
              },
              {
                defaultDisabled: {
                  enquiry: true,
                  registration: true,
                },
                key: 'fields.child.carerChildRelations.carer.surname',
                label: i18n.t('module:RegistrationForm:fields:surname'),
              },
              {
                key: 'fields.child.carerChildRelations.carer.occupation',
                label: i18n.t('module:RegistrationForm:fields:occupation'),
              },
            ],
            key: 'parentInformation',
            label: null,
          },
          {
            fields: [
              {
                defaultDisabled: {
                  enquiry: true,
                  registration: true,
                },
                key: 'fields.child.carerChildRelations.carer.email',
                label: i18n.t('module:RegistrationForm:fields:email'),
              },
              {
                key: 'fields.child.carerChildRelations.carer.telephone',
                label: i18n.t('module:RegistrationForm:fields:telephone'),
              },
              {
                key: 'fields.child.carerChildRelations.carer.mobile',
                label: i18n.t('module:RegistrationForm:fields:mobile'),
              },
              {
                key: 'fields.child.carerChildRelations.carer.workTelephone',
                label: i18n.t('module:RegistrationForm:fields:workTelephone'),
              },
            ],
            key: 'contactInformation',
            label: i18n.t('module:RegistrationForm:subGroups:contactInformation'),
          },
          {
            fields: [
              {
                doubleColumn: true,
                key: 'fields.child.carerChildRelations.carer.address',
                label: i18n.t('module:RegistrationForm:fields:address'),
              },
              {
                key: 'fields.child.carerChildRelations.carer.postCode',
                label: i18n.t('module:RegistrationForm:fields:postcode'),
              },
            ],
            key: 'address',
            label: i18n.t('module:RegistrationForm:subGroups:address'),
          },
          {
            fields: [
              {
                key: 'fields.child.carerChildRelations.relation',
                label: i18n.t('module:RegistrationForm:fields:relation'),
                placeholder: i18n.t('module:RegistrationForm:fields:relationPlaceholder'),
              },
            ],
            key: 'specificInformation',
            label: i18n.t('module:RegistrationForm:subGroups:specificInformation'),
          },
          {
            fields: [
              {
                key: 'maxParents',
                label: i18n.t('module:RegistrationForm:fields:numberOfParents'),
              },
            ],
            hideInForm: true,
            key: 'numberOfParents',
            label: i18n.t('module:RegistrationForm:subGroups:numberOfParents'),
          },
        ],
      },
    ],
    key: 'parentInformation',
    label: i18n.t('module:RegistrationForm:sections:parentInformation'),
  },
  {
    groups: [
      {
        key: 'bookingPattern',
        label: null,
        subGroups: [
          {
            asMainLabel: true,
            fields: [
              {
                doubleColumn: true,
                key: 'enrollmentDetails',
                label: i18n.t('module:RegistrationForm:fields:enrollmentDetails'),
              },
            ],
            key: 'enrollmentDetails',
            label: i18n.t('module:RegistrationForm:subGroups:enrollmentDetails'),
          },
          {
            asMainLabel: true,
            fields: [
              {
                doubleColumn: true,
                key: 'includeBookingPattern',
                label: i18n.t('module:RegistrationForm:fields:bookingPattern:title'),
              },
            ],
            key: 'bookingPattern',
            label: i18n.t('module:RegistrationForm:subGroups:bookingPattern'),
          },
        ],
      },
    ],
    hideHeader: true,
    hideInForm: true,
    key: 'bookingPattern',
    label: i18n.t('module:RegistrationForm:sections:bookingPattern'),
  },
  {
    groups: [
      {
        key: 'agreement',
        label: null,
        subGroups: [
          {
            fields: [
              {
                doubleColumn: true,
                key: 'agreement',
                label: i18n.t('module:RegistrationForm:fields:agreement'),
              },
            ],
            key: 'agreement',
            label: null,
          },
        ],
      },
    ],
    hideHeader: true,
    key: 'agreement',
    label: i18n.t('module:RegistrationForm:sections:agreement'),
  },
  {
    groups: [
      {
        key: 'termsAndConditions',
        label: null,
        subGroups: [
          {
            fields: [
              {
                doubleColumn: true,
                key: 'termsAndConditions',
                label: i18n.t('module:RegistrationForm:fields:termsAndConditions'),
              },
            ],
            key: 'termsAndConditions',
            label: null,
          },
        ],
      },
    ],
    hideHeader: true,
    key: 'termsAndConditions',
    label: i18n.t('module:RegistrationForm:sections:termsAndConditions'),
  },
]
